// PopupWrapper.js
import React, { useState } from 'react';
import '../index.css';
import { download } from '../util';
import errorImg from '../assets/error.png';
import androImg from '../assets/andro.png';
import codeImg from '../assets/code.png';
import iosImg from '../assets/ios.png';
import uploadImg from '../assets/upload.png';
import windowsImg from '../assets/windows.png';
import topImg from '../assets/top.png';
import { usePopup } from './PopupContext';

// 外层组件
const PopupWrapper = ({ child }) => {
  const { isVisible, showPopup, hidePopup } = usePopup();
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const childWithProps = React.cloneElement(child, { onClick: showPopup });

  return (
    <div>
      {childWithProps}
      {isVisible && (
        <div className='popup'>
          <div className='popup-content'>
            <div className='title'>下载客户端</div>
            <img className='error' onClick={hidePopup} src={errorImg} alt="" />
          </div>
          <div className='list'>
            <div 
              onClick={download} 
              className={`item ${hoveredItem === 'PC' ? 'hovered' : ''}`} 
              onMouseEnter={() => handleMouseEnter('PC')}
              onMouseLeave={handleMouseLeave}
            >
              <div className='hover'>
                <div className='round'>
                  <img src={uploadImg} alt="" />
                </div>
                <div className='hover-title'>
                  点击下载
                </div>
              </div>
              <div className='normal'>
                <img className='cover-img' src={windowsImg} alt="" />
                PC客户端
              </div>
              <img className='down-icon' src={topImg} alt="" />
            </div>
            <div 
              className={`item ${hoveredItem === 'Android' ? 'hovered' : ''}`}
              onMouseEnter={() => handleMouseEnter('Android')}
              onMouseLeave={handleMouseLeave}
            >
              <div className="white-box"></div>
              <div className='hover'>
                <img className='code' src={`${process.env.PUBLIC_URL}/images/android_download.jpg`} alt="" />
                <div className='hover-title'>
                  扫码下载
                </div>
              </div>
              <div className='normal'>
                <img className='cover-img' src={androImg} alt="" />
                Android
              </div>
              <img className='icon' src={codeImg} alt="" />
            </div>
            <div 
              className={`item ${hoveredItem === 'IOS' ? 'hovered' : ''}`}
              onMouseEnter={() => handleMouseEnter('IOS')}
              onMouseLeave={handleMouseLeave} 
              style={{ margin: 0 }}
            >
              <div className="white-box"></div>
              <div className='hover'>
                <img className='code' src={`${process.env.PUBLIC_URL}/images/ios_download.jpg`} alt="" />
                <div className='hover-title'>
                  扫码下载
                </div>
              </div>
              <div className='normal'>
                <img className='cover-img' src={iosImg} alt="" />
                IOS
              </div>
              <img className='icon' src={codeImg} alt="" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PopupWrapper;
